import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'

import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'

import { AppViewProvider } from '../modules/core/app/AppViewContext'
import { useAuth } from '../modules/auth'

const CompanyRoutes = () => {
  
  const { currentUser, hasRole } = useAuth();

  const ApplicantsPage = lazy(() => import('../modules/company/applicants/ApplicantsPage'))
  const ApplicationsPage = lazy(() => import('../modules/company/applications/ApplicationsPage'))
  const CertificatesPage = lazy(() => import('../modules/company/certificates/CertificatesPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const ApplicationViewPage = lazy(() => import('../modules/company/applications/view-application/ApplicationViewPage'))
  const CertificateViewPage = lazy(() => import('../modules/company/certificates/certificate-view/CertificateViewPage'))

  const DOCLabelModulePage = lazy(() => import('../modules/company/doclabel/DOCLabelModulePage'))

  const AddCompanyPage = lazy(() => import('../modules/company/companies/add-company/AddCompanyPage'));
  const MultipleFileUploaderPage = lazy( () => import('../components/utilities/multiple-file/MultipleFileUploaderPage'))

  const PricesPage = lazy(() => import('../modules/company/prices/PricesPage'));

  return (
  <AppViewProvider>
  <Routes>
    <Route element={<MasterLayout />}>
      {/* Redirect to default page after success login/registration */}
      <Route path='/auth/*' element={<Navigate to='/company/application-management/applications' />} />
      {/* Pages */}        
      <Route
        path='/company/applicant-management/*'
        element={
          <SuspensedView>
            <ApplicantsPage />
          </SuspensedView>
        }
      />
      <Route
        path='/company/application-management/*'
        element={
          <SuspensedView>
            <ApplicationsPage />
          </SuspensedView>
        }
      />
      <Route
        path='/company/certificate-management/*'
        element={
          <SuspensedView>
            <CertificatesPage />
          </SuspensedView>
        }
      />
      <Route
        path='/company/view-application/:appid/*'
        element={
          <SuspensedView>
            <ApplicationViewPage />
          </SuspensedView>
        }
      />
      <Route
        path='/company/view-certificate/:cocid'
        element={
          <SuspensedView>
            <CertificateViewPage />
          </SuspensedView>
        }
      />

      <Route
        path='/user/account/*'
        element={
          <SuspensedView>
            <AccountPage />
          </SuspensedView>
        }
      />

      <Route
        path='/company/doclabel/*'
        element={
          <SuspensedView>
            <DOCLabelModulePage />
          </SuspensedView>
        }
      />

      <Route
        path='/company/file-uploader'
        element={
          <SuspensedView>
            <MultipleFileUploaderPage />
          </SuspensedView>
        }
      />
      { (currentUser && hasRole('Management')) && 
      <Route
        path='/company/prices/*'
        element={
          <SuspensedView>
            <PricesPage />
          </SuspensedView>
        }
      />
      }

      { (currentUser && hasRole('Client Manager')) && 
      <>
      <Route
        path='/company/client-manager/add-company'
        element={
          <SuspensedView>
            <AddCompanyPage />
          </SuspensedView>
        }
      />            
      </>
      }                    
      {/* Page Not Found */}
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Route>
  </Routes>
  </AppViewProvider>    
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
      barColors: {
          '0': baseColor,
      },
      barThickness: 1,
      shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {CompanyRoutes}
